<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Registration Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>User Details</h2>
            <form @submit.prevent="handleRegister">
              <!-- Name Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">Name</label>
                  <input type="text" class="form-control" id="name" v-model="form.name" placeholder="Enter Full Name" required>
                </div>
              </div>
  
              <!-- Email Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="email">Email</label>
                  <input type="email" class="form-control" id="email" v-model="form.email" placeholder="Enter Email Address">
                </div>
              </div>
  
              <!-- Password Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="password">Password</label>
                  <input type="password" class="form-control" id="password" v-model="form.password" placeholder="Enter Password" required>
                </div>
              </div>
  
              <!-- Password Confirmation Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="password_confirmation">Confirm Password</label>
                  <input type="password" class="form-control" id="password_confirmation" v-model="form.password_confirmation" placeholder="Confirm Password" required>
                </div>
              </div>
  
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="clearForm">Cancel</button>
                  <button type="submit" class="btn btn-primary">Register</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
        },
        currentDate: '',
        currentTime: '',
      };
    },
    mounted() {
      console.log(this.$BASE_API_URL);
      this.updateDateTime();
      this.startDateTimeUpdate();
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      },
      async handleRegister() {
    if (this.form.password !== this.form.password_confirmation) {
        this.$toast.error('Passwords do not match.');
        return;
    }

    const branchId = localStorage.getItem('branchId');
    const appId = localStorage.getItem('appId');
    
    if (!appId) {
        this.$toast.error('App ID is required');
        return;
    }

    // Prepare payload
    const payload = {
        name: this.form.name,
        email: this.form.email,
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
        appId: appId, // Include appId from localStorage
        branchId: branchId // Include branchId if exists
    };

    try {
        this.$root.isLoading = true;
        this.loading = true;
        const token = localStorage.getItem('authToken');

        const response = await fetch(`${this.$BASE_API_URL}/api/users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (response.ok) {
            this.$toast.success('User created successfully!');
            this.$router.push('/users');
        } else {
            this.$toast.error('Registration failed: ' + (data.message || 'Unknown error'));
        }
    } catch (error) {
        console.error('Error:', error);
        this.$toast.error('An error occurred. Please try again.');
    } finally {
        this.$root.isLoading = false;
        this.loading = false;
    }
},
      clearForm() {
        this.$router.go(-1);
        this.form = {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
        };
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add your custom styles here */

  </style>